module.exports = __webpack_public_path__ + "static/img/crayon.c9881b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/crayon.png
// module id = 447
// module chunks = 1